import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LabelCardComponent } from './label-card.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  imports: [CommonModule, MatCardModule],
  declarations: [LabelCardComponent],
  exports: [LabelCardComponent]
})
export class LabelCardModule {}
